'use client';
import { useFormContext } from 'react-hook-form';
import { cn } from '../../utils';
import { Button } from '../ui';

export function FormSubmitButton(props: {
  className?: string;
  label?: string;
}) {
  const { formState } = useFormContext();
  return (
    <Button
      className={cn('w-full bg-red', props.className)}
      type="submit"
      loading={formState.isSubmitting}
    >
      {props.label ?? 'Submit'}
    </Button>
  );
}
